























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Route } from "vue-router";
// service methods
import { createSolution, getAcl, getSolution, updateSolution } from "@/services/solutions/solutionService";
import { getTimeZones } from "@/services/timeZones/timeZoneService";
import { getAllTemplates } from "@/services/templates/templateService";
import { validateForm } from "@/services/validation/validationService";
import validate from "@/directives/validate";
import { getSetting, setSetting } from "@/services/autoSettings/autoSettingsService";
// components
import vSelect from "vue-select";
import SolutionAccess from "@/components/solutions/SolutionAccess.vue";
import SolutionSettings from "@/components/solutions/SolutionSettings.vue";
import SolutionPreviewModal from "@/components/solutions/modals/SolutionPreviewModal.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import SolutionPowerPlan from "@/components/solutions/SolutionPowerPlan.vue";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
// types
import { Settings, Solution, SolutionTypeEnum } from "@/services/solutions/types";
import { TimeZone } from "@/services/timeZones/types";
import { boardValidators } from "@/components/solutions/validators";
import { AclMember } from "@/services/security/types";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";
import { FormComponent, FormComponentModel } from "@/services/autoSettings/types";
import i18n from "@/i18n";
import { bus } from "@/bus";
import { TemplateTypeEnum } from "@/services/templates/types";
import SolutionInfoModal from "./modals/SolutionInfoModal.vue";

@Component<SolutionForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    directives: {
        validate
    },
    components: {
        vSelect,
        SolutionAccess,
        SolutionSettings,
        SolutionPreviewModal,
        SolutionPowerPlan,
        HeaderActionButtons,
        UnsavedFormModal,
        "solution-info-modal": SolutionInfoModal
    }
})
export default class SolutionForm extends Vue {
    @Prop() private solutionId!: string;
    @Prop() private folderId!: string;
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;

    solution = {
        folderId: this.folderId ? this.folderId : "",
        name: "",
        autoScale: true,
        width: 0,
        height: 0,
        templateId: null,
        templateName: null,
        templateType: TemplateTypeEnum.informationScreen,
        timeZoneId: "",
        timeZoneName: "",
        type: SolutionTypeEnum.informationScreen,
        contractId: null,
        powerPlanId: null,
        playerId: null,
        playerName: "",
        properties: {
            roomName: "",
            roomEmail: ""
        }
    } as Solution;

    // used for comparing if form have changes
    priorSolutionState = JSON.parse(JSON.stringify(this.solution)) as Solution;
    timeZones: TimeZone[] = [];
    templates: any = [];
    validators = boardValidators;
    acl = [] as AclMember[];
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    componentsData = [] as FormComponentModel[];
    formState = false;
    routeParams = {};
    localId = this.solutionId || "";
    localAcl = [] as AclMember[];
    nextRoute = "";
    saveClicked = false;
    continue = false;

    // lifecycle hooks
    public created() {
        this.fetchData().then(() => {
            this.initComponents();
        });
    }

    // computed
    get components(): FormComponentModel[] {
        return this.componentsData.sort((x, y) => x.order - y.order);
    }

    get componentsAutoSettingKey(): string {
        let settingsKey = "solutionFormComponents";
        settingsKey += this.localId ? "-edit" : "-create";
        return settingsKey;
    }

    get settings(): Settings {
        return this.solution ? {
            name: this.solution.name,
            autoScale: this.solution.autoScale,
            height: this.solution.height,
            width: this.solution.width,
            timeZoneId: this.solution.timeZoneId,
            timeZoneName: this.solution.timeZoneName,
            templateId: this.solution.templateId,
            templateName: this.solution.templateName,
            type: this.solution.type || this.priorSolutionState.type,
            contractId: this.solution.contractId,
            powerPlanId: this.solution.powerPlanId,
            playerId: this.solution.playerId,
            playerName: this.solution.playerName,
            templateType: this.solution.templateType,
            properties: this.solution.properties ? {
                roomName: this.solution.properties.roomName || "",
                roomEmail: this.solution.properties.roomEmail || ""
            } : { roomName: "", roomEmail: "" }
        } : {} as Settings;
    }

    // methods
    async fetchData() {
        this.timeZones = await getTimeZones();
        const browserLocation = Intl.DateTimeFormat().resolvedOptions().timeZone.split("/")[1];
        const localTimeZone = this.timeZones.find(x => x.displayName.includes(browserLocation));
        this.priorSolutionState.timeZoneId = localTimeZone ? localTimeZone.id : "";
        this.solution.timeZoneId = this.priorSolutionState.timeZoneId;
        if (this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.ViewTemplatesUI])) {
            getAllTemplates().then(response => {
                this.templates = response.map(x => ({
                    id: x.id,
                    name: x.name,
                    width: x.width,
                    height: x.height
                }));
            });
        }

        if (!this.localId) return;

        getSolution(this.localId).then(response => {
            this.solution = response;
            this.priorSolutionState = JSON.parse(JSON.stringify(this.solution));
            bus.$emit("documentTitle", this.solution.name);
        });
        this.acl = await getAcl(this.localId);
        this.localAcl = JSON.parse(JSON.stringify(this.acl));
    }

    previewSolution(solutionId: string, solutionTimezoneId: string, width: number, height: number, name: string) {
        (this.$refs.boardPreviewModal as any).open(solutionId, solutionTimezoneId, width, height, name);
    }

    solutionInfo(solutionId: string) {
        (this.$refs.solutionInfoModal as any).open(solutionId);
    }

    onAccessUpdated(data: AclMember[]) {
        this.acl = data;
    }

    onSettingsUpdated(data: string) {
        const settingsData = JSON.parse(data);
        this.solution.name = settingsData.name || "";
        this.solution.autoScale = settingsData.autoScale;

        if (settingsData.type && settingsData.type === SolutionTypeEnum.sessions) {
            this.solution.width = 1280;
            this.solution.height = 800;
        } else {
            this.solution.width = settingsData.width ? parseInt(settingsData.width) : 0;
            this.solution.height = settingsData.height ? parseInt(settingsData.height) : 0;
        }

        this.solution.templateId = settingsData.templateId || null;
        this.solution.templateName = settingsData.templateName || null;
        this.solution.templateType = settingsData.templateType || TemplateTypeEnum.informationScreen;
        this.solution.timeZoneId = settingsData.timeZoneId || "";
        this.solution.timeZoneName = settingsData.timeZoneName || "";
        this.solution.type = settingsData.type || 0;
        this.solution.contractId = settingsData.contractId || null;
        this.solution.powerPlanId = settingsData.powerPlanId || null;
        this.solution.playerId = settingsData.playerId || null;
        this.solution.playerName = settingsData.playerName || "";

        this.solution.properties = {
            roomName: settingsData.properties.roomName || "",
            roomEmail: settingsData.properties.roomEmail || ""
        };
    }

    onPowerPlanUpdated(powerPlanData: any) {
        this.solution.powerPlanId = powerPlanData.powerPlanId;
        if (powerPlanData.forceOn && powerPlanData.forceOn.length > 0) {
            this.solution.forceOn = powerPlanData.forceOn;
        }
    }

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            this.retrieveData();
            const noChanges = this.lodash.isEqual(this.priorSolutionState, this.solution) && this.lodash.isEqual(this.localAcl, this.acl);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams, query: { folder: this.solution.folderId } });
        this.nextRoute = "";
    }

    async save(back: boolean) {
        this.saveClicked = true;
        await this.childComponentsHandler();
        if (!this.formState) {
            this.saveClicked = false;
            return;
        }
        this.solution.acl = this.acl.map(x => ({ id: x.id, type: x.type }));

        if (!this.localId) {
            this.solution.folderId = this.folderId;
            createSolution(this.solution).then((id: string) => {
                if (back) this.$router.push({ path: `/solutions?folder=${this.solution.folderId}` });
                else {
                    this.localId = id;
                    this.solution.id = id;
                    this.priorSolutionState = JSON.parse(JSON.stringify(this.solution)) as Solution;
                    this.localAcl = this.acl;
                    this.saveClicked = false;
                }
            });
            return;
        }

        updateSolution(this.solution).then(() => {
            if (back) this.$router.push({ path: `/solutions?folder=${this.solution.folderId}` });
            this.saveClicked = false;
            this.priorSolutionState = JSON.parse(JSON.stringify(this.solution)) as Solution;
            this.localAcl = this.acl;
        });
    }

    back() {
        window.history.go(-1);
    }

    async initComponents() {
        let components = getSetting(this.componentsAutoSettingKey);
        if (!components) {
            await setSetting(this.componentsAutoSettingKey,
                [
                    {
                        componentName: "SolutionSettings",
                        sectionName: i18n.t("common.details"),
                        order: 0,
                        collapseState: true
                    },
                    {
                        componentName: "SolutionPowerPlan",
                        sectionName: i18n.t("solution.powerOptions"),
                        order: 1,
                        collapseState: true
                    },
                    {
                        componentName: "SolutionAccess",
                        sectionName: i18n.t("solution.solutionAccess"),
                        order: 2,
                        collapseState: true
                    }] as FormComponent[]);
            components = getSetting(this.componentsAutoSettingKey);
        }

        this.componentsData = components.map((x: FormComponent) => ({
            componentName: x.componentName,
            order: x.order,
            active: false,
            activeDropTarget: false,
            collapseState: x.collapseState,
            sectionName: x.sectionName
        }));
    }

    async childComponentsHandler() {
        const components = this.$refs.childComponent as any[];
        const validators = [] as any[];
        components.forEach(component => {
            if (component.validators) { validators.push(component.validators); }
            if (typeof component.emitData === "function") { component.emitData(); }
        });

        this.formState = await validateForm(validators);
    }

    retrieveData() {
        const components = this.$refs.childComponent as any[];
        components.forEach(component => {
            if (typeof component.emitData === "function") { component.emitData(); }
        });
    }

    onComponentStateChanged(componentState: any) {
        const component = this.componentsData.find(x => x.componentName === componentState.name);
        if (!component) return;

        component.collapseState = componentState.state;
        setSetting(this.componentsAutoSettingKey,
            this.componentsData.map(x => (
                {
                    componentName: x.componentName,
                    order: x.order,
                    collapseState: x.collapseState,
                    sectionName: x.sectionName
                } as FormComponent)));
    }

    // drag & drop event handlers
    drag(event: any) {
        event.dataTransfer.setData(
            "id",
            event.target.id
        );
        const component = this.componentsData.find(x => x.componentName === event.target.id);
        if (component) {
            component.active = true;
        }
    }

    dragLeave(event: any) {
        const component = this.componentsData.find(x => x.componentName === event.currentTarget.id);
        if (!component) return;
        component.activeDropTarget = false;
    }

    dragOver(event: any) {
        event.preventDefault();
        const component = this.componentsData.find(x => x.componentName === event.currentTarget.id);
        if (!component) return;
        if (component.active) return;
        component.activeDropTarget = true;
    }

    dragEnd() {
        this.componentsData.forEach(x => {
            x.activeDropTarget = false;
            x.active = false;
        });
    }

    swapComponents(event: any) {
        event.preventDefault();
        if (!event.currentTarget) {
            return;
        }

        const target = this
            .componentsData
            .find(x => event.currentTarget && x.componentName === event.currentTarget.id);
        const source = this
            .componentsData
            .find(x => event.dataTransfer && x.componentName === event.dataTransfer.getData("id"));

        if (!(source && target)) { return; }

        const sourceOrder = source.order;
        source.order = target.order;
        target.order = sourceOrder;

        setSetting(this.componentsAutoSettingKey,
            this.componentsData.map(x => (
                {
                    componentName: x.componentName,
                    order: x.order,
                    collapseState: x.collapseState,
                    sectionName: x.sectionName
                } as FormComponent)));
    }
}
